// extracted by mini-css-extract-plugin
export default {"secondary-column-cell":"secondary-column-cell_Femop","secondaryColumnCell":"secondary-column-cell_Femop","name":"name_VbAYU"};